// ACTIONS
export const FETCH = 'offerzen/messages/FETCH'
export const FETCH_IR = 'offerzen/messages/FETCH_IR'
export const FETCH_LOADING = 'offerzen/messages/FETCH_LOADING'
export const FETCH_SUCCESS = 'offerzen/messages/FETCH_SUCCESS'

export const CREATE = 'offerzen/messages/CREATE'
export const CREATING = 'offerzen/messages/CREATING'
export const CREATE_SUCCESS = 'offerzen/messages/CREATE_SUCCESS'

export const RESET = 'offerzen/messages/RESET'

// ACTION CREATORS
export const fetch = (id, page = 1) => ({
  type: FETCH,
  payload: {
    id,
    paginate: false,
  },
})

export const fetchIR = (id, page = 1) => ({
  type: FETCH_IR,
  payload: {
    id,
    page,
  },
})

export const fetchLoading = value => ({
  type: FETCH_LOADING,
  payload: value,
})

export const fetchSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: {
    loading: false,
    messages: data.result,
    pagination: data.pagination_info,
  },
})

export const create = (id, data) => ({
  type: CREATE,
  payload: {
    id,
    data,
  },
})

export const creating = value => ({
  type: CREATING,
  payload: value,
})

export const createSuccess = data => ({
  type: CREATE_SUCCESS,
  payload: {
    creating: false,
    message: data.result,
  },
})

export const reset = () => ({
  type: RESET,
})

// REDUCERS
const initialState = {
  loading: true,
  creating: false,
}

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    case FETCH_SUCCESS:
      return {
        ...state,
        loading: action.payload.loading,
        collection: [...action.payload.messages],
        pagination: {},
      }

    case CREATING:
      return {
        ...state,
        creating: action.payload,
      }

    case CREATE_SUCCESS:
      return {
        ...state,
        creating: action.payload.creating,
        collection: [action.payload.message, ...state.collection],
      }

    case RESET:
      return initialState

    default:
      return state
  }
}

export default messagesReducer
